<template>
    <modal :show="show">
        <div slot="modalHeader">
          <modal-header :closeModal="closeModal">Preview Link</modal-header>
        </div>
        <p>Your request to create a preview link has been submitted. You can check the progress of the link creation <a href="/links" target="_blank">here</a>.</p>
        <p>The link is already available below. Click the copy icon to copy it to your clipboard</p>
        <div class="btn-group">
          <span class="label-text">URL </span><br>
          <div>
            <a class="preview-link" :href="responseData.preview_url" target="_blank">{{ responseData.preview_url }}</a>
            <button-cta title="copy to clipboard"
                        data-type="preview_url"
                        :onClick="copySingle"
                        class="btn btn-success btn-xs">
              <i class="fa fa-copy" aria-hidden="true"></i>
            </button-cta>
          </div>

          <div v-if="responseData.password && responseData.password.trim() !== ''" class="btn-group">
            <br>
            <span class="label-text">Password </span><br>
            <span class="password-text">
              {{ decodePassword(responseData.password) }}
              <button-cta title="copy to clipboard"
                          data-type="password"
                          :onClick="copySingle"
                          class="btn btn-success btn-xs">
              <i class="fa fa-copy" aria-hidden="true"></i>
            </button-cta>
            </span>
          </div>
        </div>

        <div v-if="isCopied" class="alert alert-success" role="alert" id="copiedAlert">
          <p>Information has been copied to clipboard!</p>
        </div>
        <div slot="modalFooter">
          <modal-footer :confirmTheme="'primary'" :hideCancelText="true" confirmText="Copy URL and Password" :confirm="copyToClipboard" />
        </div>
    </modal>
</template>

<script>
import Modal from '@/components/Modal/modal'
import ModalHeader from '@/components/Modal/modal-header'
import ModalFooter from '@/components/Modal/modal-footer'
import ButtonCta from '@/components/Button/button'
import {modalMixin} from '@/mixins/modalMixin'
import {creativeMixin} from '@/mixins/creativeMixin'
import {notificationMixin} from '@/mixins/notificationMixin'

export default {
  name: 'modal_preview_link',
  mixins: [modalMixin, creativeMixin, notificationMixin],
  components: {
    Modal,
    ModalHeader,
    ModalFooter,
    ButtonCta
  },
  props: {
    show: Boolean,
    confirmId: String,
    responseData: Object
  },
  data: () => ({
    isCopied: false
  }),
  mounted () {
    this.isCopied = false
  },
  computed: {
    isCopiedClass () {
      if (this.isCopied) {
        return 'success'
      } else {
        return 'primary'
      }
    }
  },
  methods: {
    decodePassword (password) {
      return decodeURIComponent(escape(window.atob(password)))
    },
    clipboard (value) {
      const el = document.createElement('textarea')
      el.value = value

      el.setAttribute('readonly', '')
      el.style.position = 'absolute'
      el.style.left = '-9999px'
      document.body.appendChild(el)
      const selected =
          document.getSelection().rangeCount > 0
            ? document.getSelection().getRangeAt(0)
            : false
      el.select()
      document.execCommand('copy')
      document.body.removeChild(el)
      this.isCopied = true
      setTimeout(() => {
        this.isCopied = false
      }, 10000)
      if (selected) {
        document.getSelection().removeAllRanges()
        document.getSelection().addRange(selected)
      }
    },
    copyToClipboard () {
      let value = ''
      if (this.responseData.password && this.responseData.password.trim() !== '') {
        value = `URL: ${this.responseData.preview_url}\nPassword: ${this.decodePassword(this.responseData.password)}`
      } else {
        value = `URL: ${this.responseData.preview_url}`
      }
      this.clipboard(value)
    },
    copySingle (evt) {
      const {type} = evt.currentTarget.dataset
      let value = ''
      if (type === 'password') {
        value = this.decodePassword(this.responseData.password)
      } else {
        value = this.responseData.preview_url
      }
      this.clipboard(value)
    },
    closeModal () {
      this.isCopied = false
      this.close()
    }
  }
}

</script>

<style lang="scss">
  #copiedAlert {
    margin-top:15px;
  }
  .btn-group {
    display: grid;
    .label-text {
      color:#00000099;
      font-weight: 700;
    }
    .password-text {
      font-weight: 400;
    }
    .preview-link {
      overflow-wrap: anywhere;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Modal/creatives/modal-preview-link.vue